import { useState } from 'react'

import { makeErrorForKey } from '../../utils'

export type LocalisationEditingKey = 'calendarIntegration' | null

type UseLocalisationSectionParams = {
  calendarData?: string[]
  savingKey: string | null
  isSaving: boolean
  mutationError?: string
  resetSaving?: () => void
}

export function useLocalisationSection({
  calendarData,
  savingKey,
  isSaving,
  mutationError,
  resetSaving
}: UseLocalisationSectionParams) {
  const [editingKey, setEditingKey] = useState<LocalisationEditingKey>(null)
  const [calendarDraft, setCalendarDraft] = useState<string[]>([])

  const startEditing = (key: LocalisationEditingKey) => {
    setEditingKey(key)

    if (key === 'calendarIntegration') setCalendarDraft(calendarData ?? [])
  }

  const cancel = () => {
    resetSaving?.()
    setEditingKey(null)
  }

  const errorForKey = makeErrorForKey(savingKey, isSaving, mutationError)

  return {
    editingKey,
    startEditing,
    cancel,
    errorForKey,
    calendarDraft,
    setCalendarDraft
  }
}
